import { render, staticRenderFns } from "./Accidents.vue?vue&type=template&id=4b84150c&"
import script from "./Accidents.vue?vue&type=script&lang=js&"
export * from "./Accidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b84150c')) {
      api.createRecord('4b84150c', component.options)
    } else {
      api.reload('4b84150c', component.options)
    }
    module.hot.accept("./Accidents.vue?vue&type=template&id=4b84150c&", function () {
      api.rerender('4b84150c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Accidents.vue"
export default component.exports